/* eslint-disable */
import {
  TourRequest_TerminationReason,
  tourRequest_TerminationReasonFromJSON,
  tourRequest_TerminationReasonToJSON,
  TourRequest_TourType,
  tourRequest_TourTypeFromJSON,
  tourRequest_TourTypeToJSON,
} from "../../../touring/data/tour_request";

export const protobufPackage = "od_protos.journey.data.categories";

export interface TourCategory {
  event?:
    | { $case: "requestCreation"; requestCreation: TourCategory_RequestCreationEvent }
    | { $case: "scheduled"; scheduled: TourCategory_ScheduledEvent }
    | { $case: "requestTermination"; requestTermination: TourCategory_RequestTerminationEvent }
    | { $case: "complete"; complete: TourCategory_CompleteEvent }
    | undefined;
}

export interface TourCategory_RequestCreationEvent {
  tourRequestId: string;
  addressUuid: string;
  showingId?: string | undefined;
  tourType: TourRequest_TourType;
}

export interface TourCategory_ScheduledEvent {
  tourRequestId: string;
  addressUuid: string;
  showingId?: string | undefined;
  tourType: TourRequest_TourType;
}

export interface TourCategory_RequestTerminationEvent {
  tourRequestId: string;
  addressUuid: string;
  showingId?: string | undefined;
  tourType: TourRequest_TourType;
  terminationReason: TourRequest_TerminationReason;
}

export interface TourCategory_CompleteEvent {
  tourRequestId: string;
  addressUuid: string;
  showingId?: string | undefined;
  tourType: TourRequest_TourType;
}

function createBaseTourCategory(): TourCategory {
  return { event: undefined };
}

export const TourCategory = {
  fromJSON(object: any): TourCategory {
    return {
      event: isSet(object.requestCreation)
        ? {
          $case: "requestCreation",
          requestCreation: TourCategory_RequestCreationEvent.fromJSON(object.requestCreation),
        }
        : isSet(object.scheduled)
        ? { $case: "scheduled", scheduled: TourCategory_ScheduledEvent.fromJSON(object.scheduled) }
        : isSet(object.requestTermination)
        ? {
          $case: "requestTermination",
          requestTermination: TourCategory_RequestTerminationEvent.fromJSON(object.requestTermination),
        }
        : isSet(object.complete)
        ? { $case: "complete", complete: TourCategory_CompleteEvent.fromJSON(object.complete) }
        : undefined,
    };
  },

  toJSON(message: TourCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "requestCreation") {
      obj.requestCreation = TourCategory_RequestCreationEvent.toJSON(message.event.requestCreation);
    }
    if (message.event?.$case === "scheduled") {
      obj.scheduled = TourCategory_ScheduledEvent.toJSON(message.event.scheduled);
    }
    if (message.event?.$case === "requestTermination") {
      obj.requestTermination = TourCategory_RequestTerminationEvent.toJSON(message.event.requestTermination);
    }
    if (message.event?.$case === "complete") {
      obj.complete = TourCategory_CompleteEvent.toJSON(message.event.complete);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TourCategory>, I>>(base?: I): TourCategory {
    return TourCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TourCategory>, I>>(object: I): TourCategory {
    const message = createBaseTourCategory();
    if (
      object.event?.$case === "requestCreation" &&
      object.event?.requestCreation !== undefined &&
      object.event?.requestCreation !== null
    ) {
      message.event = {
        $case: "requestCreation",
        requestCreation: TourCategory_RequestCreationEvent.fromPartial(object.event.requestCreation),
      };
    }
    if (
      object.event?.$case === "scheduled" && object.event?.scheduled !== undefined && object.event?.scheduled !== null
    ) {
      message.event = {
        $case: "scheduled",
        scheduled: TourCategory_ScheduledEvent.fromPartial(object.event.scheduled),
      };
    }
    if (
      object.event?.$case === "requestTermination" &&
      object.event?.requestTermination !== undefined &&
      object.event?.requestTermination !== null
    ) {
      message.event = {
        $case: "requestTermination",
        requestTermination: TourCategory_RequestTerminationEvent.fromPartial(object.event.requestTermination),
      };
    }
    if (object.event?.$case === "complete" && object.event?.complete !== undefined && object.event?.complete !== null) {
      message.event = { $case: "complete", complete: TourCategory_CompleteEvent.fromPartial(object.event.complete) };
    }
    return message;
  },
};

function createBaseTourCategory_RequestCreationEvent(): TourCategory_RequestCreationEvent {
  return { tourRequestId: "", addressUuid: "", showingId: undefined, tourType: 0 };
}

export const TourCategory_RequestCreationEvent = {
  fromJSON(object: any): TourCategory_RequestCreationEvent {
    return {
      tourRequestId: isSet(object.tourRequestId) ? String(object.tourRequestId) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
      showingId: isSet(object.showingId) ? String(object.showingId) : undefined,
      tourType: isSet(object.tourType) ? tourRequest_TourTypeFromJSON(object.tourType) : 0,
    };
  },

  toJSON(message: TourCategory_RequestCreationEvent): unknown {
    const obj: any = {};
    if (message.tourRequestId !== "") {
      obj.tourRequestId = message.tourRequestId;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    if (message.showingId !== undefined) {
      obj.showingId = message.showingId;
    }
    if (message.tourType !== 0) {
      obj.tourType = tourRequest_TourTypeToJSON(message.tourType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TourCategory_RequestCreationEvent>, I>>(
    base?: I,
  ): TourCategory_RequestCreationEvent {
    return TourCategory_RequestCreationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TourCategory_RequestCreationEvent>, I>>(
    object: I,
  ): TourCategory_RequestCreationEvent {
    const message = createBaseTourCategory_RequestCreationEvent();
    message.tourRequestId = object.tourRequestId ?? "";
    message.addressUuid = object.addressUuid ?? "";
    message.showingId = object.showingId ?? undefined;
    message.tourType = object.tourType ?? 0;
    return message;
  },
};

function createBaseTourCategory_ScheduledEvent(): TourCategory_ScheduledEvent {
  return { tourRequestId: "", addressUuid: "", showingId: undefined, tourType: 0 };
}

export const TourCategory_ScheduledEvent = {
  fromJSON(object: any): TourCategory_ScheduledEvent {
    return {
      tourRequestId: isSet(object.tourRequestId) ? String(object.tourRequestId) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
      showingId: isSet(object.showingId) ? String(object.showingId) : undefined,
      tourType: isSet(object.tourType) ? tourRequest_TourTypeFromJSON(object.tourType) : 0,
    };
  },

  toJSON(message: TourCategory_ScheduledEvent): unknown {
    const obj: any = {};
    if (message.tourRequestId !== "") {
      obj.tourRequestId = message.tourRequestId;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    if (message.showingId !== undefined) {
      obj.showingId = message.showingId;
    }
    if (message.tourType !== 0) {
      obj.tourType = tourRequest_TourTypeToJSON(message.tourType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TourCategory_ScheduledEvent>, I>>(base?: I): TourCategory_ScheduledEvent {
    return TourCategory_ScheduledEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TourCategory_ScheduledEvent>, I>>(object: I): TourCategory_ScheduledEvent {
    const message = createBaseTourCategory_ScheduledEvent();
    message.tourRequestId = object.tourRequestId ?? "";
    message.addressUuid = object.addressUuid ?? "";
    message.showingId = object.showingId ?? undefined;
    message.tourType = object.tourType ?? 0;
    return message;
  },
};

function createBaseTourCategory_RequestTerminationEvent(): TourCategory_RequestTerminationEvent {
  return { tourRequestId: "", addressUuid: "", showingId: undefined, tourType: 0, terminationReason: 0 };
}

export const TourCategory_RequestTerminationEvent = {
  fromJSON(object: any): TourCategory_RequestTerminationEvent {
    return {
      tourRequestId: isSet(object.tourRequestId) ? String(object.tourRequestId) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
      showingId: isSet(object.showingId) ? String(object.showingId) : undefined,
      tourType: isSet(object.tourType) ? tourRequest_TourTypeFromJSON(object.tourType) : 0,
      terminationReason: isSet(object.terminationReason)
        ? tourRequest_TerminationReasonFromJSON(object.terminationReason)
        : 0,
    };
  },

  toJSON(message: TourCategory_RequestTerminationEvent): unknown {
    const obj: any = {};
    if (message.tourRequestId !== "") {
      obj.tourRequestId = message.tourRequestId;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    if (message.showingId !== undefined) {
      obj.showingId = message.showingId;
    }
    if (message.tourType !== 0) {
      obj.tourType = tourRequest_TourTypeToJSON(message.tourType);
    }
    if (message.terminationReason !== 0) {
      obj.terminationReason = tourRequest_TerminationReasonToJSON(message.terminationReason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TourCategory_RequestTerminationEvent>, I>>(
    base?: I,
  ): TourCategory_RequestTerminationEvent {
    return TourCategory_RequestTerminationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TourCategory_RequestTerminationEvent>, I>>(
    object: I,
  ): TourCategory_RequestTerminationEvent {
    const message = createBaseTourCategory_RequestTerminationEvent();
    message.tourRequestId = object.tourRequestId ?? "";
    message.addressUuid = object.addressUuid ?? "";
    message.showingId = object.showingId ?? undefined;
    message.tourType = object.tourType ?? 0;
    message.terminationReason = object.terminationReason ?? 0;
    return message;
  },
};

function createBaseTourCategory_CompleteEvent(): TourCategory_CompleteEvent {
  return { tourRequestId: "", addressUuid: "", showingId: undefined, tourType: 0 };
}

export const TourCategory_CompleteEvent = {
  fromJSON(object: any): TourCategory_CompleteEvent {
    return {
      tourRequestId: isSet(object.tourRequestId) ? String(object.tourRequestId) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
      showingId: isSet(object.showingId) ? String(object.showingId) : undefined,
      tourType: isSet(object.tourType) ? tourRequest_TourTypeFromJSON(object.tourType) : 0,
    };
  },

  toJSON(message: TourCategory_CompleteEvent): unknown {
    const obj: any = {};
    if (message.tourRequestId !== "") {
      obj.tourRequestId = message.tourRequestId;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    if (message.showingId !== undefined) {
      obj.showingId = message.showingId;
    }
    if (message.tourType !== 0) {
      obj.tourType = tourRequest_TourTypeToJSON(message.tourType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TourCategory_CompleteEvent>, I>>(base?: I): TourCategory_CompleteEvent {
    return TourCategory_CompleteEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TourCategory_CompleteEvent>, I>>(object: I): TourCategory_CompleteEvent {
    const message = createBaseTourCategory_CompleteEvent();
    message.tourRequestId = object.tourRequestId ?? "";
    message.addressUuid = object.addressUuid ?? "";
    message.showingId = object.showingId ?? undefined;
    message.tourType = object.tourType ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
